import { createAction, props } from '@ngrx/store';
import { ToastModel } from '@syncfusion/ej2-angular-notifications';

export const addErrorToast = createAction('[Toast Tool] Add Error Toast', props<ToastModel>());
export const addSuccessToast = createAction('[Toast Tool] Add Success Toast', props<ToastModel>());
export const addWarningToast = createAction('[Toast Tool] Add Warning Toast', props<ToastModel>());
export const addInfoToast = createAction('[Toast Tool] Add Info Toast', props<ToastModel>());
